//Settings =================================================================================================
export const lista_motivos_recusa = [
    {value: '97', text: 'Inviabilidade Financeira'},
    {value: '101', text: 'Inviabilidade técnica'},
    {value: '293', text: 'Cliente fechou com outra empresa'},
    {value: '7711', text: 'Cliente desistiu, sem motivo definido'},
];
//======================================================================================================
